module.exports = __webpack_public_path__ + "static/media/affinity-new1.192c0909.png";